/**
 * In a hexagonal grid (honeycomb) there are 3 Dimensions in which one hexagons can be in line with another.
 */
export var Dimension;
(function (Dimension) {
    Dimension[Dimension["Vertical"] = 0] = "Vertical";
    Dimension[Dimension["Horizontal"] = 1] = "Horizontal";
    Dimension[Dimension["Diagonal"] = 2] = "Diagonal";
})(Dimension || (Dimension = {}));
/**
 * Owner of a field. A field of the Board can be either free or occupied by one player.
 */
export var FieldOwner;
(function (FieldOwner) {
    FieldOwner[FieldOwner["Free"] = 0] = "Free";
    FieldOwner[FieldOwner["Player1"] = 1] = "Player1";
    FieldOwner[FieldOwner["Player2"] = 2] = "Player2";
})(FieldOwner || (FieldOwner = {}));
